import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import Searcher from './Searcher'; //stednavne2 gives information on alternative names for a place (sted)

var BASE_URL = 'https://dawa.aws.dk/stednavne2'; //Unfortunately stednavne2 is not complete at this moment

var GET_URL = 'https://dawa.aws.dk/stednavne';
/**
 * 
 * @class Searches Dawa stednavne endpoint
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.DawaStednavnSearcher
 * @param {Object} options
 * @param {Object[]} options.types User defined type
 * @param {String} options.types[].name
 * @param {String} [options.types[].hovedtype] One of either hovedtype or
 * @param {String} [options.types[].undertype] undertype MUST be given
 * @param {String} [options.types[].iconuri]
 *
 * @example <caption>Code</caption>
 * let options: {
 *        types: [{
 *           name: 'Bebyggelse',
 *           hovedtype: 'Bebyggelse|Bygning'
 *         },{
 *           name: 'Motor og motocrossbane',
 *           undertype: 'motorbane|motocrossbane',
 *           iconuri: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzc5LjgyODEyNSAwaC0yMTcuNjU2MjVjLTcyLjg3NSAwLTEzMi4xNzE4NzUgNTkuMjk2ODc1LTEzMi4xNzE4NzUgMTMyLjE3MTg3NXY3OC44MjgxMjVoLTMwdjMwaDEyMHYtMzBoLTMwdi03OC44MjgxMjVjMC0zOS44MDA3ODEgMzIuMzcxMDk0LTcyLjE3MTg3NSA3Mi4xNzE4NzUtNzIuMTcxODc1aDIxNy42NTYyNWMzOS44MDA3ODEgMCA3Mi4xNzE4NzUgMzIuMzcxMDk0IDcyLjE3MTg3NSA3Mi4xNzE4NzV2NjFjMCAzMS4xMTMyODEtMTkuODM1OTM4IDU4LjYyNS00OS4zNTE1NjIgNjguNDY4NzVsLTYwLjc4OTA2MyAyMC4yNTc4MTNjLTQxLjc3NzM0NCAxMy45NDUzMTItNjkuODU5Mzc1IDUzLjg5NDUzMS02OS44NTkzNzUgOTcuOTI5Njg3IDAgMzkuODAwNzgxLTMzLjM3MTA5NCA3Mi4xNzE4NzUtNzMuMTcxODc1IDcyLjE3MTg3NWgtMzYuNjU2MjVjLTM5LjgwMDc4MSAwLTcyLjE3MTg3NS0zMi4zNzEwOTQtNzIuMTcxODc1LTcyLjE3MTg3NXYtNzguODI4MTI1aDMwdi0zMGgtMTIwdjMwaDMwdjc4LjgyODEyNWMwIDcyLjg3NSA1OS4yOTY4NzUgMTMyLjE3MTg3NSAxMzIuMTcxODc1IDEzMi4xNzE4NzVoMzYuNjU2MjVjNzIuODc1IDAgMTMzLjE3MTg3NS01OS4yOTY4NzUgMTMzLjE3MTg3NS0xMzIuMTcxODc1IDAtMTguMTc5Njg3IDExLjU4NTkzOC0zNS4yNSAyOC44NDM3NS00MS4wMDc4MTNsNjAuNzg5MDYyLTIwLjI2OTUzMWM1NC4wNTQ2ODgtMTguMDE5NTMxIDkwLjM2NzE4OC02OC40MTAxNTYgOTAuMzY3MTg4LTEyNS4zNzg5MDZ2LTYxYzAtNzIuODc1LTU5LjI5Njg3NS0xMzIuMTcxODc1LTEzMi4xNzE4NzUtMTMyLjE3MTg3NXptMCAwIi8+PC9zdmc+'
 *         }]
 *       }
 * searchers.push({searcher: new DawaStednavnSearcher(options)})
 */

export default Class(Searcher, {
  initialize: function initialize(options) {
    this.options = options;
    this.source = "Dawa";
    this.Searcher(options);
    this.myTypes = [];

    if (options.types) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = options.types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var type = _step.value;
          var id = type.id ? type.id : type.name;
          var type2Register = {
            id: id,
            singular: type.singular ? type.singular : id,
            plural: type.plural ? type.plural : id
          };
          type2Register.hovedtype = type.hovedtype;
          type2Register.undertype = type.undertype;
          this.myTypes.push(type2Register);
          this.registerType(this.source, type2Register);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      var _type2Register = {
        id: 'stednavn',
        singular: 'Stednavn',
        plural: 'Stednavne'
      };
      this.myTypes.push(_type2Register);
      this.registerType(this.source, _type2Register);
    }

    this.kommunekode = null;
    if (options.kommunekode) this.kommunekode = options.kommunekode;
    this.visUOfficiel = false;
    if (options.visUOfficiel) this.visUOfficiel = options.visUOfficiel;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = caller;
              _context.next = 3;
              return this.query(query);

            case 3:
              _context.t1 = _context.sent;

              _context.t0.fetchSuccess.call(_context.t0, _context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  query: function () {
    var _query2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_query) {
      var typesToSearch, queryResult, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, type, title, items, count, hitsShown, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item, newQuery, _newQuery;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              typesToSearch = this.myTypes;
              if (_query.hasTarget) typesToSearch = [this.myTypes.find(function (t) {
                return t.id === _query.target.type;
              })];
              queryResult = this.createQueryResult();
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 6;
              _iterator2 = typesToSearch[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context2.next = 43;
                break;
              }

              type = _step2.value;
              title = type.plural;
              _context2.next = 13;
              return this.fetchItems(_query, type, Math.max(_query.limit, 100) + 1);

            case 13:
              items = _context2.sent;
              count = items.length;

              if (!(["list", "cut", "no-cut"].indexOf(_query.type) !== -1)) {
                _context2.next = 39;
                break;
              }

              hitsShown = count === 1 ? 1 : _query.type === 'no-cut' && count > _query.limit ? 0 : Math.min(count, _query.limit);
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context2.prev = 20;

              for (_iterator3 = items.slice(0, hitsShown)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                item = _step3.value;
                this.addItemAsResult(queryResult, type, item);
              }

              _context2.next = 28;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](20);
              _didIteratorError3 = true;
              _iteratorError3 = _context2.t0;

            case 28:
              _context2.prev = 28;
              _context2.prev = 29;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 31:
              _context2.prev = 31;

              if (!_didIteratorError3) {
                _context2.next = 34;
                break;
              }

              throw _iteratorError3;

            case 34:
              return _context2.finish(31);

            case 35:
              return _context2.finish(28);

            case 36:
              if (count > hitsShown && ["no-cut", "cut"].indexOf(_query.type) !== -1) {
                if (count > Math.max(_query.limit, 100)) title += " (".concat(Math.max(_query.limit, 100), "+)");else title += " (".concat(count, ")");
                newQuery = queryResult.addNewQuery(this.source, type.id, title, null, _query.queryString, null, null);
                if (typeof type.iconuri !== 'undefined') newQuery.image = type.iconuri;else if (typeof this.options.iconuri !== 'undefined') newQuery.image = this.options.iconuri;
              }

              _context2.next = 40;
              break;

            case 39:
              if (count > 0) {
                _newQuery = queryResult.addNewQuery(this.source, type.id, title, null, _query.queryString, null, null);
                if (typeof type.iconuri !== 'undefined') _newQuery.image = type.iconuri;else if (typeof this.options.iconuri !== 'undefined') _newQuery.image = this.options.iconuri;
              }

            case 40:
              _iteratorNormalCompletion2 = true;
              _context2.next = 8;
              break;

            case 43:
              _context2.next = 49;
              break;

            case 45:
              _context2.prev = 45;
              _context2.t1 = _context2["catch"](6);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t1;

            case 49:
              _context2.prev = 49;
              _context2.prev = 50;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 52:
              _context2.prev = 52;

              if (!_didIteratorError2) {
                _context2.next = 55;
                break;
              }

              throw _iteratorError2;

            case 55:
              return _context2.finish(52);

            case 56:
              return _context2.finish(49);

            case 57:
              return _context2.abrupt("return", queryResult);

            case 58:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[6, 45, 49, 57], [20, 24, 28, 36], [29,, 31, 35], [50,, 52, 56]]);
    }));

    function query(_x3) {
      return _query2.apply(this, arguments);
    }

    return query;
  }(),
  fetchItems: function () {
    var _fetchItems = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(query, type, limit) {
      var typeCriteria, params, items, queryParam, filteredItems;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              limit = limit || query.limit;
              if (typeof type.hovedtype !== 'undefined') typeCriteria = "hovedtype=".concat(type.hovedtype);else typeCriteria = "undertype=".concat(type.undertype); //https://dawa.aws.dk/dok/api/generelt#tekstsoegning

              params = {};
              if (this.kommunekode != null) params.kommunekode = this.kommunekode;

              if (!(query.queryString.length > 0)) {
                _context3.next = 11;
                break;
              }

              queryParam = query.queryString + '*';
              _context3.next = 8;
              return fetch2("".concat(BASE_URL, "/?q=").concat(queryParam, "&").concat(typeCriteria, "&per_side=").concat(limit), {
                data: params
              });

            case 8:
              items = _context3.sent;
              _context3.next = 16;
              break;

            case 11:
              _context3.next = 13;
              return fetch2("".concat(BASE_URL, "/?").concat(typeCriteria, "&per_side=").concat(limit + 100), {
                data: params
              });

            case 13:
              items = _context3.sent;
              items.sort(function (item1, item2) {
                return item1.navn.localeCompare(item2.navn);
              });
              items = items.slice(0, limit);

            case 16:
              filteredItems = this.removeDuplicates(items);
              return _context3.abrupt("return", filteredItems);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetchItems(_x4, _x5, _x6) {
      return _fetchItems.apply(this, arguments);
    }

    return fetchItems;
  }(),
  removeDuplicates: function removeDuplicates(items) {
    //https://ilikekillnerds.com/2016/05/removing-duplicate-objects-array-property-name-javascript/
    return items.filter(function (item, pos, arr) {
      return arr.map(function (mapObj) {
        return mapObj.sted.id;
      }).indexOf(item.sted.id) === pos;
    });
  },
  addItemAsResult: function addItemAsResult(results, type, item) {
    var navn = item.navn,
        navnestatus = item.navnestatus,
        sted = item.sted;
    var itemId = sted.id; // Enrich name with alternatives

    if (navnestatus === 'officielt' || navnestatus === 'suAutoriseret') {
      if (sted["primærtnavn"].length > 0 && sted["primærnavnestatus"] === 'uofficielt') navn += ' (' + sted["primærtnavn"] + ')';else if (this.visUOfficiel && sted["sekundærenavne"].length > 0 && sted["sekundærenavne"][0].navnestatus === 'uofficielt') navn += ' (' + sted["sekundærenavne"][0].navn + ')';
    } else if (navnestatus === 'uofficielt') {
      if (sted["primærtnavn"].length > 0 && sted["primærnavnestatus"] === 'officielt') navn += ' (' + sted["primærtnavn"] + ')';else if (sted["sekundærenavne"].length > 0 && sted["sekundærenavne"][0].navnestatus === 'officielt') navn += ' (' + sted["sekundærenavne"][0].navn + ')';
    } //Create a description


    var description = null;
    if (typeof sted.kommuner !== 'undefined') description = sted.kommuner[0].navn;

    if (typeof type.hovedtype !== 'undefined' && type.hovedtype.indexOf('|') > -1) {
      if (type.hovedtype.indexOf('|') > -1) description = sted.hovedtype + (description ? ', ' + description : '');
    } else {
      if (type.undertype.indexOf('|') > -1) description = this.capitalizeFirstLetter(sted.undertype) + (description ? ', ' + description : '');
    }

    var result = results.addResult(this.source, type.id, navn, description, null, item);
    result.id = itemId;
    result.isComplete = false;
    if (typeof type.iconuri !== 'undefined') result.image = type.iconuri;else if (typeof this.options.iconuri !== 'undefined') result.image = this.options.iconuri;
  },
  capitalizeFirstLetter: function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
  },
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(result) {
      var feature;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!result.isComplete) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", result);

            case 4:
              result.isComplete = true;
              _context4.next = 7;
              return this.get(result.id, result.type);

            case 7:
              feature = _context4.sent;
              result.geometry = feature.geometry;
              return _context4.abrupt("return", result);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function completeResult(_x7) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(id, typeName) {
      var type, feature, results, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              type = this.options.types.find(function (type) {
                return type.name === typeName;
              });
              _context5.next = 3;
              return fetch2("".concat(GET_URL, "/").concat(id, "?format=geojson&srid=25832"));

            case 3:
              feature = _context5.sent;
              results = this.createQueryResult();
              result = this.addFeatureAsResult(results, type, feature);
              return _context5.abrupt("return", result);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function get(_x8, _x9) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  addFeatureAsResult: function addFeatureAsResult(results, type, feature) {
    var geometry = feature.geometry,
        properties = feature.properties;
    var result = results.addResult(this.source, type.name, properties.navn, null, geometry, feature);
    result.id = properties.id;
    return result;
  },
  CLASS_NAME: 'Septima.Search.DawaStednavnSearcher'
});